import React from 'react'
import { connect } from 'react-redux'
import { compact } from 'lodash'

import { closeModal } from '../actions'
import { trapTab } from '../focusTrap'

import { CancelWhiteIcon, CancelIcon } from 'icons'
import css from './style.scss'

export class Modal extends React.Component {
  constructor (props) {
    super(props)
    this.handleClose = this.handleClose.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.handleOverlayClick = this.handleOverlayClick.bind(this)
  }

  componentDidMount () {
    this.previousFocus = document.activeElement
    this.dialog.focus()
  }

  componentWillUnmount () {
    if (this.previousFocus && this.previousFocus.focus) this.previousFocus.focus()
  }

  handleClose () {
    (this.props.onRequestClose || this.props.closeModal)()
  }

  handleKeyDown (event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      event.stopPropagation()
      this.handleClose()
    } else if (event.key === 'Tab' || event.keyCode === 9) {
      trapTab(event, this.dialog)
    }
  }

  handleOverlayClick (event) {
    if (event.target === event.currentTarget) this.handleClose()
  }

  render () {
    const props = this.props
    const modalClasses = [
      props.borderlessModal ? css.borderlessModal : css.modal,
      props.disableOverflowY ? '' : css.overflowY
    ]

    const buttonClasses = [
      css.closeButton,
      props.cancelBtnSize ? css[`btn${props.cancelBtnSize}`] : css.btnmedium,
      props.cancelBtnCornerPosition ? css[`btncorner${props.cancelBtnCornerPosition}`] : css.btncornermedium
    ]
    return (
      <div
        className={css.overlay}
        onClick={this.handleOverlayClick}
      >
        <div
          className={compact(modalClasses).join(' ')}
          role='dialog'
          aria-modal='true'
          aria-labelledby={props.labelledBy}
          aria-label={props.labelledBy ? undefined : (props.contentLabel || 'Dialog')}
          tabIndex='-1'
          onKeyDown={this.handleKeyDown}
          ref={(el) => { this.dialog = el }}
        >
          <button
            className={compact(buttonClasses).join(' ')}
            type='button'
            aria-label='Close'
            onClick={this.handleClose}
          >
            {props.cancelBtnColor && props.cancelBtnColor === 'white' && <CancelWhiteIcon aria-hidden='true' />}
            {props.cancelBtnColor && props.cancelBtnColor === 'black' && <CancelIcon aria-hidden='true' />}
            {!props.cancelBtnColor && <CancelIcon aria-hidden='true' />}
          </button>
          <div className={css.overflowModalContent}>
            {props.children}
          </div>
        </div>
      </div>
    )
  }
}

Modal.propTypes = {
  /**
   * set to enable borderless modal
   * disabled by default
   */
  borderlessModal: React.PropTypes.bool,
  /**
   * Available values: white, black
   * default value: black
   */
  cancelBtnColor: React.PropTypes.string,
  /**
   * Available values: small, medium
   * default value: medium
   */
  cancelBtnSize: React.PropTypes.string,
  /**
   * Available values: close, medium
   * default value: medium
   */
  cancelBtnCornerPosition: React.PropTypes.string,
  /**
   * Accessible name, used when labelledBy is not set
   * default value: Dialog
   */
  contentLabel: React.PropTypes.string,
  /**
   * id of the element that names the dialog (e.g. its heading)
   */
  labelledBy: React.PropTypes.string,
  /**
   * set to disable overflow Y
   * enabled by default
   */
  disableOverflowY: React.PropTypes.bool,
  onRequestClose: React.PropTypes.func
}

export default connect(null, { closeModal })(Modal)
